import { MESSAGE_TYPE } from '@/api/enums.js';

export function chatSearchKey(chat) {
	if (!chat) {
		return '';
	}
	return String(chat.type) + ':' + String(chat.targetId);
}

function includesKeyword(text, keyword) {
	if (text === undefined || text === null || text === '') {
		return false;
	}
	return String(text).toLowerCase().indexOf(keyword) >= 0;
}

function stripHtml(html) {
	if (!html) {
		return '';
	}
	return String(html)
		.replace(/<[^>]+>/g, ' ')
		.replace(/&nbsp;/gi, ' ')
		.replace(/&amp;/gi, '&')
		.replace(/&lt;/gi, '<')
		.replace(/&gt;/gi, '>')
		.replace(/\u00A0/g, ' ');
}

function pushJsonSearchText(parts, content) {
	if (content === undefined || content === null || content === '') {
		return;
	}
	try {
		const obj = typeof content === 'string' ? JSON.parse(content) : content;
		if (!obj || typeof obj !== 'object') {
			parts.push(content);
			return;
		}
		if (obj.name) {
			parts.push(obj.name);
		}
		if (obj.nickName) {
			parts.push(obj.nickName);
		}
		if (obj.groupName) {
			parts.push(obj.groupName);
		}
		if (obj.title) {
			parts.push(obj.title);
		}
	} catch (e) {
		parts.push(content);
	}
}

export function extractMessageSearchText(msg) {
	if (!msg) {
		return '';
	}
	const parts = [];
	if (msg.sendNickName) {
		parts.push(msg.sendNickName);
	}
	if (msg.title) {
		parts.push(msg.title);
	}
	const type = msg.type;
	const content = msg.content;
	if (type === MESSAGE_TYPE.FILE || type === MESSAGE_TYPE.USER_CARD || type === MESSAGE_TYPE.GROUP_CARD) {
		pushJsonSearchText(parts, content);
	} else if (
		type === MESSAGE_TYPE.TEXT ||
		type === MESSAGE_TYPE.TIP_TEXT ||
		type === MESSAGE_TYPE.RECALL ||
		type === MESSAGE_TYPE.SYSTEM_MESSAGE
	) {
		parts.push(stripHtml(content));
	} else if (typeof content === 'string' && content && content.charAt(0) !== '{' && content.charAt(0) !== '[') {
		parts.push(stripHtml(content));
	}
	return parts.filter(Boolean).join(' ');
}

export function messagesMatchKeyword(messages, keyword) {
	if (!keyword || !Array.isArray(messages) || !messages.length) {
		return false;
	}
	for (let i = 0; i < messages.length; i++) {
		if (includesKeyword(extractMessageSearchText(messages[i]), keyword)) {
			return true;
		}
	}
	return false;
}

export function chatMetaMatchesKeyword(chat, keyword) {
	if (!chat || !keyword) {
		return false;
	}
	return includesKeyword(chat.showName, keyword) ||
		includesKeyword(chat.lastContent, keyword) ||
		includesKeyword(chat.sendNickName, keyword) ||
		includesKeyword(stripHtml(chat.draftContent), keyword);
}

export function chatMatchesKeyword(chat, keyword) {
	if (!chat || !keyword) {
		return false;
	}
	return chatMetaMatchesKeyword(chat, keyword) || messagesMatchKeyword(chat.messages, keyword);
}
